import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { NstiStockImportFileHelperContainerModel } from '../../../../../../models/aggregates/erp/non-stock-and-trade-in/nsti-stock-import-file-helper-container.model';
@Injectable({
  providedIn: 'root'
})
export class NstiStockImportFileHelperService extends BaseApiTemplateService<NstiStockImportFileHelperContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/stock-import-file-helpers/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/stock-import-file-helpers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/stock-import-file-helpers/backoffice-ep';
    this.httpClient = http;
  }

}
